import type { ViduV1Category, ViduV1Template } from '@/app/services/vidu';

export { templatesList, templatesListCategories } from '@/app/services/vidu';

export type Template = ViduV1Template;

export type TemplateCategory = ViduV1Category;
